import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

const token = z.string().min(32).max(128).regex(/^[A-Za-z0-9_-]+$/);

// Public: access is gated by knowledge of the unguessable quote token.
export const getQuoteByToken = createServerFn({ method: "GET" })
  .inputValidator(z.object({ token }).parse)
  .handler(async ({ data }) => {
    const { getQuoteByTokenServer } = await import("./quotes.server");
    return getQuoteByTokenServer(data);
  });

export const createQuoteCheckout = createServerFn({ method: "POST" })
  .inputValidator(
    z.object({
      token,
      items: z
        .array(z.object({ slug: z.string().max(64), qty: z.number().int().min(0).max(10000) }))
        .min(1)
        .max(20),
    }).parse,
  )
  .handler(async ({ data }) => {
    const { createQuoteCheckoutServer } = await import("./quotes.server");
    return createQuoteCheckoutServer(data);
  });
